/**
 * Cruce entre el e-RUT y el documento del representante legal.
 *
 * El e-RUT tiene que haberlo descargado del SII el mismo representante legal
 * cuya identidad se verifica con la cedula. Se compara contra `rutUsuario`, que
 * es quien lo descargo.
 *
 * Ojo: `rutUsuario` NO esta respaldado por el QR del documento, a diferencia del
 * RUT de la sociedad y la razon social. La coincidencia es una verificacion de
 * coherencia, no una prueba de autenticidad.
 *
 * Vive en un util y no dentro de un componente porque lo usan dos: el paso del
 * OCR lo consulta apenas lee el documento —para no hacerle capturar el reverso y
 * la selfie a alguien que igual va a quedar bloqueado— y el del representante
 * legal lo vuelve a evaluar para dibujar la comparacion y frenar el envio.
 */

/** Deja el RUT en digitos + DV, sin puntos ni guion, con la K en mayuscula. */
export function normalizarRut(rut: string | null | undefined): string {
  if (!rut) return '';
  return rut.replace(/[^0-9kK]/g, '').toUpperCase();
}

/**
 * ¿El e-RUT lo descargo otra persona?
 *
 * Sin alguno de los dos datos devuelve `false`: el e-RUT puede no traer
 * `rutUsuario`, y ante la falta de dato no se bloquea a nadie.
 */
export function erutEsDeOtraPersona(
  rutRepresentante: string | null | undefined,
  rutUsuarioDelErut: string | null | undefined
): boolean {
  const representante = normalizarRut(rutRepresentante);
  const usuario = normalizarRut(rutUsuarioDelErut);

  if (!representante || !usuario) return false;

  return representante !== usuario;
}
